import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Grid } from '@material-ui/core';
// import { useDispatch } from 'react-redux';
import UserSearch from '../UserSearch';
import SignIn from '../SignIn';
import BuilderProfilePersonalContainer from '../BuilderProfilePersonalContainer';
import Notification from '../Notification';
import BuilderJobsContainer from '../BuilderJobs/BuilderJobsContainer';
import { COLORS } from '../../constants';
import AwaitingApproval from '../AwaitingApproval';
import BuilderProfileBusinessContainer from '../BuilderProfilePersonalContainer/BuilderProfileBusinessContainer';
import TabPanel from '../TabPanel';
import ServiceAreaContainer from '../ServiceAreaContainer';
import NotificationSettingsContainer from '../NotificationSettingsContainer';
import AdditionalInformationContainer from '../AdditionalInformationContainer';
import PhotoAwaitingApproval from '../PhotoAwaitngApproval';
import ActivityLog from '../ActivityLog';
export const LandingComponent = props => {
  const [builder, setBuilder] = useState(null);
  // const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getBusinessAttributes());
  }, []);
  const {
    auth,
    classes,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
    notification,
  } = props;
  const { loggedIn } = auth;
  useEffect(() => {
    if (!loggedIn) {
      // resetting the builder on logout
      setBuilder(null);
    }
  }, [loggedIn]);
  const style = {
    page: {},
    layout: {},
    backBtn: {
      backgroundColor: COLORS.GREEN,
      color: COLORS.WHITE,
      marginBottom: '0.5rem',
    },
    button: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
      width: '300px',
    },
    buttonInv: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.GREEN,
      backgroundColor: COLORS.WHITE,
      width: '300px',
    },
    heading: {
      textAlign: 'center',
      fontSize: '2rem',
      margin: '2rem',
    },
  };
  const [currentSection, setCurrentSection] = useState('search');
  const handleSectionChange = (event, newValue) => {
    setCurrentSection(newValue);
  };
  const [profileTab, setProfileTab] = React.useState('profile');
  const handleChange = (event, newValue) => {
    setProfileTab(newValue);
  };

  const getTabComponent = () => {
    if (currentSection === 'search') {
      return (
        <UserSearch
          setBuilder={setBuilder}
          dispatchApiCallFailed={dispatchApiCallFailed}
          dispatchApiCallSuccess={dispatchApiCallSuccess}
        />
      );
    }
    if (currentSection === 'approval') {
      return (
        <AwaitingApproval
          dispatchApiCallFailed={dispatchApiCallFailed}
          dispatchApiCallSuccess={dispatchApiCallSuccess}
        />
      );
    }
    return (
      <PhotoAwaitingApproval
        setBuilder={setBuilder}
        dispatchApiCallFailed={dispatchApiCallFailed}
        dispatchApiCallSuccess={dispatchApiCallSuccess}
      />
    );
  };
  return (
    <div style={style.page}>
      <div style={style.layout}>
        <Notification
          notification={notification}
          dispatchApiCallSuccess={dispatchApiCallSuccess}
        />
        {!loggedIn && (
          <SignIn dispatchApiCallSuccess={dispatchApiCallSuccess} />
        )}
        {loggedIn && (
          <>
            {builder ? (
              <>
                <div className={classes.root}>
                  <div className={classes.innerWrapper}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <FlatButton
                          label="Back"
                          style={style.backBtn}
                          onClick={() => {
                            setBuilder(null);
                            setProfileTab('profile');
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Tabs
                          TabIndicatorProps={{
                            style: {
                              background: `${COLORS.GREEN}`,
                            },
                          }}
                          value={profileTab}
                          onChange={handleChange}
                          textColor={COLORS.GREY_DARK}
                          variant="standard"
                        >
                          <Tab label="Builder Profile" value="profile" />
                          <Tab label="Service Area" value="service" />
                          <Tab label="Job Notification" value="notification" />
                          <Tab label="Additional Info" value="additional" />
                          <Tab label="Activity Log" value="activityLog" />
                        </Tabs>
                      </Grid>
                      <Grid item xs={12}>
                        <TabPanel value={profileTab} index="profile">
                          <Grid container xs={12} spacing="3">
                            <Grid item md={4} xs={12}>
                              <BuilderProfilePersonalContainer
                                userAttributes={builder}
                                setBuilder={setBuilder}
                                dispatchApiCallFailed={dispatchApiCallFailed}
                                dispatchApiCallSuccess={dispatchApiCallSuccess}
                              />
                            </Grid>
                            <Grid item md={8} xs={12}>
                              <BuilderProfileBusinessContainer
                                enableEditing
                                businessId={builder.username}
                              />
                            </Grid>
                          </Grid>
                          <BuilderJobsContainer
                            builder={builder}
                            dispatchApiCallFailed={dispatchApiCallFailed}
                            dispatchApiCallSuccess={dispatchApiCallSuccess}
                          />
                        </TabPanel>
                        <TabPanel value={profileTab} index="service">
                          <ServiceAreaContainer
                            enableEditing
                            businessId={builder.username}
                          />
                        </TabPanel>
                        <TabPanel value={profileTab} index="notification">
                          <NotificationSettingsContainer
                            enableEditing
                            businessId={builder.username}
                          />
                        </TabPanel>
                        <TabPanel value={profileTab} index="additional">
                          <AdditionalInformationContainer
                            enableEditing
                            userAttributes={builder}
                            setBuilder={setBuilder}
                            businessId={builder.username}
                          />
                        </TabPanel>
                        <TabPanel value={profileTab} index="activityLog">
                          <ActivityLog builderId={builder.username} />
                        </TabPanel>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div style={style.heading}>
                  <ToggleButtonGroup onChange={handleSectionChange} exclusive>
                    <ToggleButton
                      fullWidth
                      value="search"
                      style={
                        currentSection === 'search'
                          ? style.button
                          : style.buttonInv
                      }
                    >
                      Search Users
                    </ToggleButton>
                    <ToggleButton
                      value="approval"
                      style={
                        currentSection === 'approval'
                          ? style.button
                          : style.buttonInv
                      }
                    >
                      Awaiting Approval
                    </ToggleButton>
                    <ToggleButton
                      value="photoApproval"
                      style={
                        currentSection === 'photoApproval'
                          ? style.button
                          : style.buttonInv
                      }
                    >
                      Photos Awaiting Approval
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
                {getTabComponent()}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const propTypes = {
  auth: PropTypes.object,
  classes: PropTypes.any,
  dispatchApiCallFailed: PropTypes.any,
  dispatchApiCallSuccess: PropTypes.any,
  notification: PropTypes.any,
};

LandingComponent.propTypes = propTypes;
